import { render, staticRenderFns } from "./PaperResultPC.vue?vue&type=template&id=7aba948b&scoped=true&"
import script from "./PaperResultPC.vue?vue&type=script&lang=js&"
export * from "./PaperResultPC.vue?vue&type=script&lang=js&"
import style0 from "./PaperResultPC.vue?vue&type=style&index=0&id=7aba948b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aba948b",
  null
  
)

export default component.exports